const filtroBusquedaRCDetalleState = {
  loading: false,
  busquedarecargos: false,
  recargosConvenidosExcep: [],
};

export default filtroBusquedaRCDetalleState;

